/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyersectionimage2Inputs */

const en_flyersectionimage2 = /** @type {(inputs: Flyersectionimage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image`)
};

const de_flyersectionimage2 = /** @type {(inputs: Flyersectionimage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild`)
};

/**
* | output |
* | --- |
* | "Image" |
*
* @param {Flyersectionimage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyersectionimage2 = /** @type {((inputs?: Flyersectionimage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyersectionimage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyersectionimage2(inputs)
	return de_flyersectionimage2(inputs)
});
export { flyersectionimage2 as "flyerSectionImage" }